module.exports = __webpack_public_path__ + "static/media/YB5M01_4.c8cc0d29.jpg";